import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  signal,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { NkChanges } from '@nk/utils-lib';
import { buildPageItems, DEFAULT_MAX_SIZE, DEFAULT_PAGE, PageItem, shiftPageItems } from './pagination.utils';

@Component({
  selector: 'nk-pagination',
  imports: [TranslateModule],
  templateUrl: './pagination.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationComponent implements OnInit, OnChanges {
  /**
   * Default page is 0
   */
  @Input() public currentPage = DEFAULT_PAGE;
  @Input() public totalItems: number | undefined;
  /**
   * Default page is 3
   */
  @Input() public maxSize = DEFAULT_MAX_SIZE;
  @Input() public itemsPerPage: number | undefined;
  @Output() public changePage = new EventEmitter<number>();
  @Input() public andClass = '';

  public lastPage: number | undefined;

  public pageItems = signal<PageItem[]>([]);

  constructor(private _cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.setPaginationParams();
  }

  public ngOnChanges(changes: NkChanges<PaginationComponent>): void {
    if (
      typeof changes.totalItems?.currentValue === 'number' ||
      typeof changes.maxSize?.currentValue === 'number' ||
      typeof changes.itemsPerPage?.currentValue === 'number'
    ) {
      this.setPaginationParams();
    }
  }

  public setPaginationParams(): void {
    if (typeof this.totalItems !== 'number') {
      this.totalItems = DEFAULT_MAX_SIZE;
    }
    if (typeof this.itemsPerPage !== 'number') {
      this.itemsPerPage = DEFAULT_MAX_SIZE;
    }
    this.lastPage = Math.ceil(this.totalItems / this.itemsPerPage) - 1;
    this.maxSize = this.lastPage < this.maxSize ? this.lastPage + 1 : this.maxSize;
    let shift: number | undefined;
    if (this.currentPage > this.lastPage - this.maxSize + 1) {
      shift = this.lastPage - this.maxSize + 1;
    } else {
      shift = this.currentPage;
    }
    const pages = buildPageItems(this.maxSize, shift);
    this.pageItems.set(pages);
  }

  public setPage(page: number | undefined, pageItems: PageItem[]): void {
    if (typeof page === 'number' && typeof this.lastPage === 'number') {
      this.currentPage = page;
      const shiftedPages = shiftPageItems(this.currentPage, pageItems, this.maxSize, this.lastPage);
      if (shiftedPages) {
        this.pageItems.set(shiftedPages);
      }
      this._cdr.markForCheck();
      this.changePage.emit(this.currentPage);
    }
  }
}
